module.exports = __webpack_public_path__ + "media/Video 49.214e379a.mp4";